module.exports = __webpack_public_path__ + "static/friend-finder-869db2de7d248f69fa57da1b2f97c5e5.jpg";